// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const AlertSuccess = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
            <path
                fill="#00A65A"
                d="M9 18.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-.527-6.152-.598.597-.598-.597-2.812-2.813L5.66 8.09l2.215 2.215L12.34 5.84l1.195 1.195-5.062 5.063Z"
            />
        </svg>
    );
};

export default React.memo(AlertSuccess);
